import React from "react";
import Backdrop from "@material-ui/core/Backdrop";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 9999,
  },
}));

function OverlayBackdrop({ open }) {
  const classes = useStyles();
  return <Backdrop className={classes.backdrop} open={open} />;
}

OverlayBackdrop.propTypes = {
  open: PropTypes.bool,
};

OverlayBackdrop.defaultProps = {
  open: false,
};

export default OverlayBackdrop;
